import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getViewParticularAnnouncementSlice = createApi(`GetViewParticularAnnouncementSlice`,"GET");

const GetViewParticularAnnouncementSlice = createSlice({
  name: 'GetViewParticularAnnouncementSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getViewParticularAnnouncementSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getViewParticularAnnouncementSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getViewParticularAnnouncementSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetViewParticularAnnouncementSlice.reducer;